function validateEmail(email) {
    var re = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;
    return re.test(email);
}

function validatePhoneNumber(phoneNumber) {
    var re = /^(\+\d{1,3})?[-.\s]?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
    return re.test(phoneNumber);
}

function createPopup(title, content, doTransition = true) {
    // Create the dark background
    const background = document.createElement('div');
    background.className = 'popup-background';
    background.style.display = 'block';
    background.style.position = 'fixed';
    background.style.top = '0';
    background.style.left = '0';
    background.style.width = '100%';
    background.style.height = '100%';
    background.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    background.style.zIndex = '998';
    //   Blur everything behind background
    background.style.backdropFilter = 'blur(5px)';
    // disable scrolling behind the background
    document.body.style.overflow = 'hidden';
    // background.addEventListener("click", () => {
    //     document.body.removeChild(background);
    //     document.body.removeChild(popup);
    //     document.body.style.overflow = "initial";
    // });
    document.body.appendChild(background);

    // Create the popup
    const popup = document.createElement('div');

    window.removePopup = () => {
        // document.body.removeChild(document.querySelector(".popup-background"));
        // document.body.removeChild(document.querySelector(".popup"));
        popup.remove();
        background.remove();
        document.body.style.overflow = 'initial';
    };

    background.addEventListener('click', removePopup);

    popup.className = 'popup';
    // popup.style.position = "fixed";
    // popup.style.top = "50%";
    // popup.style.left = "50%";
    // popup.style.transform = "translate(-50%, -50%)";
    // popup.style.width = "95vmin";
    // popup.style.aspectRatio = "300/218";
    // popup.style.backgroundColor = "white";
    // popup.style.border = "1px solid lightgray";
    // popup.style.borderRadius = "5px";
    // popup.style.padding = "10px";
    // popup.style.display = "flex";
    // popup.style.flexDirection = "column";
    // popup.style.justifyContent = "space-between";
    // popup.style.alignItems = "center";
    // popup.style.zIndex = "999";
    document.body.appendChild(popup);

    popup.style.transform = 'translate(-50%, -50%)';

    if (doTransition) {
        //   use css transitions to make the popup appear
        popup.style.transition = 'top 0.3s ease-in-out 0.15s, opacity 0.3s ease-in-out 0.15s';
        popup.style.top = '45%';
        popup.style.opacity = 0;
        background.style.backgroundColor = 'rgba(0, 0, 0, 0)';
        background.style.backdropFilter = 'blur(0px)';
        background.style.transition =
            'background-color 0.3s ease-in-out, backdrop-filter 0.3s ease-in-out';

        setTimeout(() => {
            popup.style.top = '50%';
            popup.style.opacity = 1;
            background.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
            background.style.backdropFilter = 'blur(5px)';
            // background.
        }, 100);
    }

    // background.style.transition = "background-color 0.5s ease-in-out";
    // // background.style.transform = "scale(0)";
    // background.style.backgroundColor = "rgba(0, 0, 0, 0)"
    // setTimeout(() => {
    //     // popup.style.transform = "scale(1)";
    //     background.style.backgroundColor = "rgba(0, 0, 0, 0.5)"
    // }, 100);

    // Create the title
    const popupTitle = document.createElement('h2');
    popupTitle.textContent = title;
    popupTitle.style.margin = '0';
    //   popupTitle.style.marginBottom = "1rem";
    popupTitle.style.textAlign = 'center';
    popup.appendChild(popupTitle);

    // Create the content div
    const contentDiv = document.createElement('div');
    contentDiv.style.width = '100%';
    contentDiv.className = 'content-div';

    contentDiv.append(content);

    popup.appendChild(contentDiv);

    // Create the close button
    const closeButton = document.createElement('button');
    closeButton.className = 'close-button';
    closeButton.textContent = 'Close';
    closeButton.style.padding = '0.5rem 1rem';
    closeButton.style.border = 'none';
    closeButton.style.borderRadius = '5px';
    closeButton.style.backgroundColor = '#379c44';

    closeButton.style.cursor = 'pointer';
    closeButton.style.color = 'white';

    closeButton.onclick = () => {
        document.body.removeChild(background);
        document.body.removeChild(popup);
        document.body.style.overflow = 'initial';
    };
    popup.appendChild(closeButton);

    return popup;
}

const createPlantingGuidePopup = () =>
    createPopup(
        '',
        (() => {
            let img = document.createElement('img');
            img.style.width = '100%';
            img.style.maxWidth = '800px';
            img.style.height = 'auto';
            img.src =
                'https://cdn.shopify.com/s/files/1/0886/9658/6534/files/Planting_Guide_800.jpg?v=1721665468';
            return img;
        })(),
    );

function createContactPopup() {
    let proContent = document.getElementById('landscapePopup');
    let content = document.createElement('div');

    Array.from(proContent.children).forEach(child => {
        content.appendChild(child.cloneNode(true));
    });

    content.style.width = '100%';
    content.style.height = '100%';

    formatElement(content);

    let popup = createPopup('', content);
    popup.classList.add('pro-popup');

    let closeButton = popup.querySelector('.close-button');

    closeButton.textContent = 'Cancel';

    let btnWrapper = document.createElement('div');
    btnWrapper.style.display = 'flex';
    btnWrapper.style.justifyContent = 'center';
    btnWrapper.style.alignItems = 'center';
    btnWrapper.style.gap = '1rem';

    closeButton.before(btnWrapper);
    btnWrapper.appendChild(closeButton);

    let submitButton = closeButton.cloneNode(true);
    submitButton.textContent = 'Submit';
    submitButton.className = 'submit-button';
    btnWrapper.appendChild(submitButton);

    closeButton.style.backgroundColor = 'transparent';
    closeButton.style.border = 'solid 1px rgba(0, 0, 0, 0.3)';
    closeButton.style.color = 'var(--color-foreground)';

    popup.querySelector('.content-div').style.paddingBottom = '1rem';
    popup.querySelector('.content-div').style.paddingTop = '1rem';

    let form = popup.querySelector('form');

    let firstName = form.querySelector('input[name="firstName"]');
    let lastName = form.querySelector('input[name="lastName"]');
    let email = form.querySelector('input[name="email"]');
    let phoneNumber = form.querySelector('input[name="phoneNumber"]');

    let street = form.querySelector('input[name="street"]');
    let city = form.querySelector('input[name="city"]');
    let state = form.querySelector('select[name="state"]');
    let zip = form.querySelector('input[name="zip"]');
    let comments = form.querySelector('textarea');

    setTimeout(() => {
        firstName.value = localStorage.getItem('landscape-firstName') || '';
        lastName.value = localStorage.getItem('landscape-lastName') || '';
        email.value = localStorage.getItem('landscape-email') || '';
        phoneNumber.value = localStorage.getItem('landscape-phoneNumber') || '';
        street.value = localStorage.getItem('landscape-street') || '';
        city.value = localStorage.getItem('landscape-city') || '';
        state.value = localStorage.getItem('landscape-state') || '';
        zip.value = localStorage.getItem('landscape-zip') || '';
        comments.value = localStorage.getItem('landscape-comments') || '';

        if (firstName.value != '') firstName.classList.remove('empty');
        if (lastName.value != '') lastName.classList.remove('empty');
        if (email.value != '') email.classList.remove('empty');
        if (phoneNumber.value != '') phoneNumber.classList.remove('empty');
        if (street.value != '') street.classList.remove('empty');
        if (city.value != '') city.classList.remove('empty');
        if (state.value != '') {
            let cosmeticEl = state.parentElement.querySelector('.fancy-dropdown-cosmetic');

            let states = {
                NC: 'North Carolina',
                SC: 'South Carolina',
                VA: 'Virginia',
                WV: 'West Virginia',
                GA: 'Georgia',
                TN: 'Tennessee',
            };

            cosmeticEl.innerText = states[state.value] || state.value;
            cosmeticEl.style.color = '#000';
        }
        if (zip.value != '') zip.classList.remove('empty');
        // if (comments.value != '') comments.classList.remove('empty');
    }, 250);

    firstName.addEventListener('input', e => {
        localStorage.setItem('landscape-firstName', e.target.value);
    });

    lastName.addEventListener('input', e => {
        localStorage.setItem('landscape-lastName', e.target.value);
    });

    email.addEventListener('input', e => {
        localStorage.setItem('landscape-email', e.target.value);
    });

    phoneNumber.addEventListener('input', e => {
        localStorage.setItem('landscape-phoneNumber', e.target.value);
    });

    street.addEventListener('input', e => {
        localStorage.setItem('landscape-street', e.target.value);
    });

    city.addEventListener('input', e => {
        localStorage.setItem('landscape-city', e.target.value);
    });

    state.addEventListener('input', e => {
        localStorage.setItem('landscape-state', e.target.value);
    });

    zip.addEventListener('input', e => {
        localStorage.setItem('landscape-zip', e.target.value);
    });

    comments.addEventListener('input', e => {
        localStorage.setItem('landscape-comments', e.target.value);
    });

    form.getFormData = () => {
        let interestedIn = Array.from(form.querySelectorAll('input[type="checkbox"]:checked')).map(
            v => v.value,
        );
        let getStarted = form.querySelector('input[name="getStarted"]:checked').value;

        return {
            first_name: firstName.value,
            last_name: lastName.value,
            email: email.value,
            phone: phoneNumber.value,
            interested_in: interestedIn,
            timeline: getStarted,
            street: street.value,
            city: city.value,
            state: state.value,
            zip_code: zip.value,
            comments: comments.value,
            'ngrok-skip-browser-warning': 'skip',
        };
    };

    function submitData(e) {
        e.preventDefault();

        let data;

        try {
            data = form.getFormData();
        } catch (e) {
            alert('Please fill out all fields.');
            return;
        }

        if (data.interested_in.length == 0) {
            alert('Please select at least one interest.');
            return;
        }

        if (!validateEmail(data.email)) {
            alert('Please enter a valid email address.');
            return;
        }

        if (!validatePhoneNumber(data.phone)) {
            alert('Please enter a valid phone number.');
            return;
        }

        if (data.first_name == '' || data.last_name == '') {
            alert('Please enter your name.');
            return;
        }

        if (data.state == ' ') data.state = '';

        let body = JSON.stringify(data);

        grecaptcha.ready(function () {
            grecaptcha
                .execute('6LcGARMqAAAAALjAhYoFdENy3p5ArHtMkJrS4lLt', {
                    action: 'submit',
                })
                .then(function (token) {
                    fetch(`https://api.settlemyrenursery.com/design`, {
                        method: 'POST',
                        body: body,
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`,
                        },
                    })
                        .then(response => Promise.all([response.text(), response.status]))
                        .then(([data, status]) => {
                            if (status == 200) {
                                localStorage.removeItem('landscape-firstName');
                                localStorage.removeItem('landscape-lastName');
                                localStorage.removeItem('landscape-email');
                                localStorage.removeItem('landscape-phoneNumber');
                                localStorage.removeItem('landscape-interestedIn');
                                localStorage.removeItem('landscape-getStarted');
                                localStorage.removeItem('landscape-street');
                                localStorage.removeItem('landscape-city');
                                localStorage.removeItem('landscape-state');
                                localStorage.removeItem('landscape-zip');
                                localStorage.removeItem('landscape-comments');

                                removePopup();
                                createPopup('Thank you!', data);
                            } else {
                                removePopup();
                                let _popup = createPopup('Oops!', data);
                                let _button = _popup.querySelector('.close-button');
                                _button.textContent = 'Try again';
                                _button.onclick = () => {
                                    removePopup();
                                    createContactPopup();
                                };
                            }
                        })
                        .catch(error => {
                            removePopup();
                            let _popup = createPopup(
                                'Oops!',
                                'Something went wrong. Please try again.',
                            );
                            let _button = _popup.querySelector('.close-button');
                            _button.textContent = 'Try again';
                            _button.onclick = () => {
                                removePopup();
                                createContactPopup();
                            };
                        });
                });
        });
    }

    form.addEventListener('submit', submitData);
    submitButton.addEventListener('click', submitData);
}

// proShowAt is the time at which the popup should be shown
const proShowAt = (set = null) => {
    if (set != null) sessionStorage.setItem('pro-show-at', set);
    if (set == '') sessionStorage.removeItem('pro-show-at');
    return sessionStorage.getItem('pro-show-at');
};

// seenPromo is the last time the popup was shown
const seenPromo = (set = null) => {
    if (set != null) localStorage.setItem('pro-last-seen', set);
    if (set == '') localStorage.removeItem('pro-last-seen');
    return localStorage.getItem('pro-last-seen');
};

// noWantPromo is whether the user has explicitly
// said they don't want the popup to show
const noWantPromo = (set = null) => {
    if (set != null) localStorage.setItem('pro-no-want', set);
    if (set == '') localStorage.removeItem('pro-no-want');
    return localStorage.getItem('pro-no-want');
};

const reallyNoWantPromo = (set = null) => {
    if (set != null) sessionStorage.setItem('pro-really-no-want', set);
    if (set == '') sessionStorage.removeItem('pro-really-no-want');
    return sessionStorage.getItem('pro-really-no-want');
};

async function submitNewsletterForm(e) {
    e.preventDefault();
    return new Promise((resolve, reject) => {
        grecaptcha.ready(function () {
            grecaptcha
                .execute('6LcGARMqAAAAALjAhYoFdENy3p5ArHtMkJrS4lLt', {
                    action: 'submit',
                })
                .then(async function (token) {
                    const form = e.target;

                    const email = form.querySelector('input[type="email"]').value;
                    form.reset();

                    if (!validateEmail(email)) return alert('Please enter a valid email address.');

                    const response = await fetch(`https://api.settlemyrenursery.com/newsletter`, {
                        method: 'POST',
                        body: JSON.stringify({
                            email,
                            site: 'commercial',
                            'ngrok-skip-browser-warning': 'skip',
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`,
                        },
                    });
                    const [rText, rStatus] = await Promise.all([response.text(), response.status]);
                    const _head = rStatus == 200 ? 'Thank you!' : 'Oops!';
                    let _cont =
                        rStatus == 200
                            ? 'Please check your email to receive a discount code.'
                            : rText;

                    if (rStatus == 200) {
                        noWantPromo(true);
                        reallyNoWantPromo(true);
                    }

                    try {
                        window.removePopup();
                    } catch (e) {}
                    createPopup(_head, _cont);
                })
                .then(() => {
                    resolve();
                })
                .catch(e => {
                    reject(e);
                });
        });
    });
}

function createPromotionalPopup() {
    let proContent = document.getElementById('promotionalPopup');
    let content = document.createElement('div');

    Array.from(proContent.children).forEach(child => {
        content.appendChild(child.cloneNode(true));
    });

    content.querySelector('a').addEventListener('click', e => {
        e.preventDefault();
        noWantPromo(true);
        window.removePopup();
    });

    let popup = createPopup('', content);
    popup.classList.add('pro-popup');
    popup.querySelector('.close-button').remove();
    popup.querySelector('.content-div').style.paddingBottom = '1rem';

    let form = popup.querySelector('.claim-form');
    let emailInput = form.querySelector('input[type="email"]');
    let btn = form.querySelector('button');

    form.addEventListener('submit', e => {
        e.preventDefault();

        btn.textContent = '';
        btn.disabled = true;
        btn.style.width = '4rem';
        btn.style.height = '4rem';
        btn.style.borderRadius = '50%';
        btn.style.backgroundColor = 'transparent';
        btn.style.border = '4px solid white';
        btn.style.borderLeft = '4px solid #379c44';
        btn.style.padding = '0';
        btn.style.animation = 'spin 1s linear infinite';
        btn.style.cursor = 'wait';
        btn.classList.add('btn-loading');

        submitNewsletterForm(e);
    });

    emailInput.addEventListener('input', e => {
        if (validateEmail(emailInput.value)) {
            btn.classList.add('valid');
            btn.disabled = false;
        } else {
            btn.classList.remove('valid');
            btn.disabled = true;
        }
    });
}

function customerOpenedPopup() {
    return Array.from(document.querySelectorAll('.pro-popup')).length > 0;
}

function promoLogic() {
    if (noWantPromo()) return;

    const seenPromoTime = !seenPromo() ? 0 : seenPromo();
    const showAgainAt = +seenPromoTime + 1000 * 60 * 60 * 24 * 4;

    if (seenPromo() && Date.now() < showAgainAt) return;

    if (!seenPromo() && !proShowAt()) proShowAt(Date.now() + 1000 * 5);

    let promoCreated = false;

    createPromo();

    function createPromo() {
        if (proShowAt() <= Date.now() && !promoCreated) {
            promoCreated = true;
            if (customerOpenedPopup() || window.CUSTOMER_ORDER_COUNT > 0) return;
            createPromotionalPopup();
            seenPromo(Date.now());
            proShowAt('');
        }
    }

    for (let i = 0; i < 7000; i += 1000) {
        setTimeout(createPromo, 5000);
    }
}

const DISABLED_PAGES = [
    '/pages/commercial',
    '/pages/login',
    '/pages/register',
    '/pages/finish',
    '/pages/reset-password',
    '/pages/forgot-password',
];

window.onload = () => {
    try {
        const promotionalPuller = document.getElementById('promotionalPuller');
        promotionalPuller.classList.add('hide');
        // Disabled for now...
        // const openButton = promotionalPuller.querySelector(".open-button");
        // const closeButton = promotionalPuller.querySelector(".close-button");
        //
        // openButton.addEventListener("click", () => {
        //     createPromotionalPopup();
        //     seenPromo(Date.now());
        //     proShowAt("");
        // });
        //
        // closeButton.addEventListener("click", () => {
        //     noWantPromo(true);
        //     reallyNoWantPromo(true);
        //     promotionalPuller.classList.add("hide");
        // });
        //
        // if (!reallyNoWantPromo() && window.CUSTOMER_ORDER_COUNT == 0)
        //     promotionalPuller.classList.remove("hide");

        // if (!DISABLED_PAGES.some((page) => window.location.pathname.includes(page)))
        //     promoLogic();
    } catch (e) {
        console.error(e);
    }

    try {
        if (document.getElementById('commercialPuller')) {
            const commercialPuller = document.getElementById('commercialPuller');
            const openButton = commercialPuller.querySelector('.open-button');
            const closeButton = commercialPuller.querySelector('.close-button');

            openButton.addEventListener('click', () => {
                createCommercialPopup();
            });

            closeButton.addEventListener('click', () => {
                closeCommercialPuller(true);
                commercialPuller.classList.add('hide');
            });
        }
    } catch (e) {
        console.error('Commercial Puller', e);
    }
};

window.createPopup = createPopup;
window.createContactPopup = createContactPopup;
window.createPromotionalPopup = createPromotionalPopup;

// if (window.localStorage.getItem('pro-show') == 'true') createPromotionalPopup();

function createCommercialPopup() {
    let popContent = document.getElementById('commercialPopup');
    let content = document.createElement('div');

    Array.from(popContent.children).forEach(child => {
        content.appendChild(child.cloneNode(true));
    });

    formatElement(content);

    let popup = createPopup('', content);

    return popup;
}

function closeCommercialPuller(set = null) {
    if (set != null) return sessionStorage.setItem('close-commercial-puller', set);
    let val = sessionStorage.getItem('close-commercial-puller');
    if (val == undefined) {
        sessionStorage.setItem('close-commercial-puller', false);
        return false;
    } else if (val == 'true') {
        return true;
    } else {
        return false;
    }
}

function createWorkshopPopup() {
    let text = `<p>Join us for our exciting Fall Container Gardening Workshop! Learn how to create stunning and vibrant container gardens that will brighten up your outdoor space for the season ahead. Our knowledgeable experts will guide you through the process, from selecting the right plants and containers to arranging them for maximum impact. Whether you're a beginner or seasoned gardener, this workshop is perfect for anyone looking to add a touch of color and beauty to their patio, balcony, or garden. Don't miss out on this opportunity to unleash your creativity and elevate your gardening skills! Reserve your spot today by adding this to your shopping cart. Be sure to shop our beautiful planters and make your selection. We can't wait to see you there!</p><em>Please arrive at 8:50am, you will also receive a 10% coupon valid to use and shop with on the workshop day. Bring a friend!</em><br><br><strong>*<span style="text-decoration: underline;">MUST</span> purchase this class and your choice of planter.</strong>`;
    let el = document.createElement('div');
    el.innerHTML = text;

    createPopup('Workshop', el);
}
